import React, { Component } from 'react';
import { Input, Button, Card, Alert, Divider, Image, Row, Col } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import firebase from "firebase";

import Header from '../common/Header';
import Status from '../common/Status';
import SearchSkeleton from './SearchSkeleton';

class SearchUser extends Component {
  state = {
    phoneNumber: '',
    usersCount: '',
    currentUser: '',
    viewSearchResult: false,
    showAlert: false,
    showSkeleton: false,
    alertType: 'error',
    alertMessage: 'Please enter Mobile number!',
  }

  componentDidMount = () => {
    let ref = firebase.database().ref(`/`);
    ref.on("value", snapshot => {
      const users = snapshot.val();
      const usersCount = (users && Object.keys(users).length) || 0;
      this.setState({usersCount});
    });
  };
  
  onChangeInput = (event) => {
    this.setState({ phoneNumber: event.target.value });
  }

  onSearchUser = () => {
    const { phoneNumber } = this.state

    this.setState({ showSkeleton: true, viewSearchResult: false, })
    let ref = firebase.database().ref(`/${phoneNumber}`);

    ref.on("value", snapshot => {
      const currentUser = snapshot.val();
      let newStateProperties = { showSkeleton: false, showAlert: true, alertType: 'error', phoneNumber: '' }

      if(!phoneNumber) {
        newStateProperties.alertMessage = 'Please enter mobile number.'
      } else if(!currentUser) {
        newStateProperties.alertMessage = `Sorry! Mobile number -  ${phoneNumber} not found.`
      } else {
        newStateProperties = {currentUser, viewSearchResult: true, phoneNumber: ''}
      }
      this.setState({ ...newStateProperties })
    });
  }

  onImageLoad = () => {
    this.setState({ showSkeleton: false });
  }

  renderSearchFormFooter = () => {
    const { usersCount } = this.state
    return (
      <Row>
        <Col span={12} className='total-users'>
          {this.renderUserColumn('Total Users', usersCount)}
        </Col>
        <Col span={12} className='find-user-button'>
          <Button type="primary" onClick={this.onSearchUser} >
            Search
          </Button>
        </Col>
      </Row>
    )
  }

  renderSearchForm = () => {
    const { phoneNumber } = this.state

    return (
      <div>
        <Header title="SEARCH USER"/>
        <Input
          prefix={<PhoneOutlined className="site-form-item-icon" />}
          type="number"
          placeholder="Enter Mobile Number"
          onChange={this.onChangeInput}
          value={phoneNumber}
          className='find-user-input'
        />
        {this.renderSearchFormFooter()}      
      </div>
    )
  }

  renderUserColumn = (columnName, columnValue) => {
    return (
      <div className='column-container'>
        <div className='column-name'>{columnName}</div>
        <div className='column-value'>{columnValue}</div>
      </div>
    )
  }

  renderUserProfile = () => {
    const { currentUser, showSkeleton } = this.state
    const { imageUrl, name, phoneNumber, registrationDate } = currentUser;

    return (
      <div className='user-profile' hidden={showSkeleton}>
        {this.renderUserColumn('Name', name)}
        {this.renderUserColumn('Mobile Number', phoneNumber)}
        {this.renderUserColumn('Registration Date', registrationDate)}
        {this.renderUserColumn('Photo', '')}
        <Image
          width={250}
          src={imageUrl}
          onLoad={this.onImageLoad}
        />
      </div>

    )
  }

  renderSearchResult = () => {
    const { currentUser } = this.state

    return (
      <React.Fragment>
        <Divider/>
        {currentUser ? this.renderUserProfile() : <Alert type='error' message='Sorry! User not found.'/>}
      </React.Fragment>
    )
  }

  render() {
    const { showAlert, alertType, alertMessage } = this.state

    return (
      <div className='add-user-container'>
        <Card style={{ textAlign: 'center', paddingTop: '30px' }} >
          {this.renderSearchForm()}
          { this.state.viewSearchResult && this.renderSearchResult()}
          {this.state.showSkeleton && <SearchSkeleton/>}
        </Card>
        {showAlert && <Status type={alertType} message={alertMessage} />}
      </div>
    );
  }
}
 
export default SearchUser;